import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-detalle-reporte',
  templateUrl: './detalle-reporte.component.html',
  styleUrls: ['./detalle-reporte.component.scss']
})
export class DetalleReporteComponent implements OnInit {

    @Input() columns: Record<string, any>[] = [];
    @Input() items: any[] = [];
    @Input() isModulo: boolean = false;
    @Input() filterBy: string;
    @Input() crud: boolean = false;
    @Input() scrollable: boolean = false;
    @Input() scrollHeight: string = '18rem'
    @Input() esNuevo: boolean = true;
    @Input() editando: boolean = false;
    // @Input() scrollHeight: string

    @Output() onClickRow = new EventEmitter();
    @Output() onBtnSelect = new EventEmitter();
    @Output() onBtnNew = new EventEmitter();
    @Output() onBtnDelete = new EventEmitter();

    constructor() { }

    ngOnInit(): void {
    }

    async onClick( obj: FormGroup, editar?: boolean ) {
        if ( editar ) {
            this.onClickRow.emit( obj );
        }
        if ( !this.isModulo ) {
            this.onClickRow.emit( obj );
        }
    }

    getOptionLabel( options: any[], field: any ) {
        let label = '';
        if ( options ) {
            for (const option of options) {
                if ( String(option.valor) === String(field) ) {
                    label += option.nombre;
                }
            }
        }
        return label;
    }

    async btnSelect( obj: Record<string, any> ) {
        this.onBtnSelect.emit( obj );
    }

    async btnNew() {
        this.onBtnNew.emit();
    }

    async btnDelete( obj: FormGroup ) {
        this.onBtnDelete.emit( obj );
    }

    filter( obj: Record<string, any> ) {
        if ( this.filterBy ) {
            if ( obj.modulo === this.filterBy ) {
                return true;
            }
            return false;
        }
        return true;
    }

}
